import { render, staticRenderFns } from "./PrimePhoneInput.vue?vue&type=template&id=5f04b661"
import script from "./PrimePhoneInput.vue?vue&type=script&lang=js"
export * from "./PrimePhoneInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports